import { useRequest } from "ahooks";
import request from "../../../network/request";
import { ProvinceTypes } from "../interfaces/home";

// 存储省份城市数据
export default function useCitiesData() {
  return useRequest<ProvinceTypes[], any[]>(
    async () => {
      try {
        return await request("/module/maintenance/serviceCityTree", {}, "POST");
      } catch (err) {
        console.log((err as any).message, "获取服务省/城市列表失败提示信息");
        throw err;
      }
    },
    {
      cacheKey: "/module/maintenance/serviceCityTree",
      staleTime: 1000 * 60 * 60,
    }
  );
}
